import { useState, useEffect } from "react";

const COOKIE_PREFERENCES_KEY = "cookie_criacasa_preferences";

type CookiePreferences = {
  preference: boolean;
  marketing: boolean;
  statistics: boolean;
};

export function useCookieConsent() {
  const [preferences, setPreferences] = useState<CookiePreferences | null>(
    null
  );

  useEffect(() => {
    const storedPreferences = localStorage.getItem(COOKIE_PREFERENCES_KEY);
    if (storedPreferences) {
      setPreferences(JSON.parse(storedPreferences));
    }
  }, []);

  const updatePreferences = (newPreferences: CookiePreferences) => {
    localStorage.setItem(
      COOKIE_PREFERENCES_KEY,
      JSON.stringify(newPreferences)
    );
    setPreferences(newPreferences);
  };

  return { preferences, updatePreferences, setPreferences };
}
